import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "personalDetails" };
const _hoisted_2 = {
    key: 0,
    class: "well"
};
const _hoisted_3 = { class: "anchor-bottom" };
import { ref, reactive, onMounted, getCurrentInstance, useTemplateRef } from 'vue';
import { useRouter } from 'vue-router';
import { useAuth } from '@/composables/useAuth';
import HeaderBlock from './elements/HeaderBlock.vue';
import InputSections from './elements/InputSections.vue';
import MGButton from './elements/MGButton.vue';
import EnableWhatsAppWidget from './elements/EnableWhatsAppWidget.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PersonalDetailsPage',
    setup(__props) {
        const router = useRouter();
        useAuth();
        const instance = getCurrentInstance();
        const cookies = instance?.appContext.config.globalProperties.$cookies;
        const inputSections = useTemplateRef('inputSections');
        const validationText = ref(null);
        const sectionNo = ref(0);
        const enableWhatsApp = ref(false);
        const currentPageNumber = ref(0);
        const breadCrumb = reactive([]);
        const sections = reactive([
            {
                title: 'Your name',
                subtitle: null,
                fields: [
                    { validationText: 'Please complete all fields', label: 'First Name', type: 'text', required: true, value: null },
                    { validationText: 'Please complete all fields', label: 'Last Name', type: 'text', required: true, value: null }
                ]
            },
            {
                title: 'Mobile phone number',
                subtitle: null,
                fields: [
                    { validationText: 'Please complete all fields', label: '+44', type: 'number', required: true, value: null, subtitle: 'We never share any of your personal information with your employer. We never share any of your personal information with a third party, without your consent.' }
                ]
            },
            {
                title: 'Personal information',
                subtitle: null,
                fields: [
                    { validationText: 'Please complete all fields', label: 'Date of birth', type: 'datetext', required: true, value: null },
                    { validationText: 'Please complete all fields', label: 'Postcode', type: 'text', required: true, value: null }
                ]
            },
            {
                title: 'Email and password',
                subtitle: "<h3>Money is personal.</h3>You can use an email address of your choice and set a password.",
                fields: [
                    { validationText: 'Please complete all fields', label: 'Email address', type: 'email', required: true, value: null },
                    { validationText: 'Please complete all fields', label: 'Password', type: 'password', required: true, value: null },
                    { validationText: 'Please accept the terms & conditions', label: 'Accept below terms & conditions', link: "https://www.moneyguided.com/#/terms", linkLabel: 'Click here to view our Terms & Conditions', type: 'check', required: true, value: null }
                ]
            }
        ]);
        function findFieldValue(fieldName) {
            for (const section of sections) {
                for (const field of section.fields) {
                    if (field.label === fieldName && field.value != null) {
                        return field.value;
                    }
                }
            }
            return null;
        }
        function stringToDate(dateString) {
            if (!dateString || dateString === 'NaN/NaN/NaN') {
                return null;
            }
            const [day, month, year] = dateString.split('/');
            return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
        }
        function sectionAllowed(section) {
            if (!section.rule) {
                return true;
            }
            const [ruleKey, ruleValue] = section.rule.split(':').map((s) => s.trim());
            const ruleValues = ruleValue.split(',').map((s) => s.trim());
            for (let i = 0; i < sectionNo.value; i++) {
                const sec = sections[i];
                for (const field of sec.fields) {
                    if (field.id === ruleKey && ruleValues.includes(field.value)) {
                        return true;
                    }
                }
            }
            return false;
        }
        function inputControlGoNext(onFinished = null, before = null) {
            validationText.value = '';
            let allOK = true;
            if (before) {
                if (!before()) {
                    return;
                }
            }
            for (const field of sections[sectionNo.value].fields) {
                if (field.required && (!field.value || field.value === "")) {
                    validationText.value = field.validationText;
                    allOK = false;
                    break;
                }
                if (field.type === 'datetext' && field.value && field.value.length < 10) {
                    validationText.value = "Please enter date in the format dd/mm/yyyy";
                    allOK = false;
                    break;
                }
                if (field.strongPass != undefined && field.strongPass == false) {
                    validationText.value = "Your password is not strong enough";
                    allOK = false;
                    break;
                }
            }
            if (allOK) {
                let allowed = false;
                breadCrumb.push({ sectionNo: sectionNo.value });
                while (!allowed) {
                    validationText.value = null;
                    sectionNo.value++;
                    if (!sections[sectionNo.value]) {
                        if (onFinished) {
                            onFinished();
                            return;
                        }
                    }
                    else {
                        allowed = sectionAllowed(sections[sectionNo.value]);
                    }
                }
                currentPageNumber.value++;
                inputSections.value?.next(sectionNo.value);
            }
            setTimeout(() => { validationText.value = null; }, 4000);
        }
        function registerUser() {
            const userObject = {
                firstName: findFieldValue('First Name'),
                lastName: findFieldValue('Last Name'),
                phone: findFieldValue('+44'),
                dob: stringToDate(findFieldValue('Date of birth')),
                postCode: findFieldValue('Postcode'),
                email: findFieldValue('Email address'),
                password: findFieldValue('Password'),
                employerId: cookies?.get('employerId'),
                enableWhatsApp: enableWhatsApp.value,
            };
            localStorage.setItem('registerUser', JSON.stringify(userObject));
            cookies?.remove('employerId');
            router.push({ path: '/createaccount' });
        }
        onMounted(() => {
            if (!cookies?.get('employerId')) {
                router.push({ path: '/getstarted' });
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: "",
                    bgcolor: "transparent",
                    border: "0"
                }),
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(InputSections, {
                        ref_key: "inputSections",
                        ref: inputSections,
                        sections: sections
                    }, null, 8, ["sections"]),
                    (validationText.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createElementVNode("p", null, _toDisplayString(validationText.value), 1)
                        ]))
                        : _createCommentVNode("", true),
                    (sectionNo.value == 1)
                        ? (_openBlock(), _createBlock(EnableWhatsAppWidget, {
                            key: 1,
                            onOn: _cache[0] || (_cache[0] = ($event) => (enableWhatsApp.value = true)),
                            onOff: _cache[1] || (_cache[1] = ($event) => (enableWhatsApp.value = false))
                        }))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(MGButton, {
                            alt: true,
                            text: "continue",
                            arrow: true,
                            onClick: _cache[2] || (_cache[2] = ($event) => (inputControlGoNext(registerUser)))
                        })
                    ])
                ])
            ], 64));
        };
    }
});
